import React from 'react'

export function TvIcon(stroke?: string) {
    return (
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5920_3579)">
                <path
                    d="M13.7676 1.66699L9.80924 5.62533L5.85091 1.66699M3.47591 5.62533H16.1426C17.017 5.62533 17.7259 6.33421 17.7259 7.20866V15.917C17.7259 16.7914 17.017 17.5003 16.1426 17.5003H3.47591C2.60146 17.5003 1.89258 16.7914 1.89258 15.917V7.20866C1.89258 6.33421 2.60146 5.62533 3.47591 5.62533Z"
                    stroke={stroke || 'white'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_5920_3579">
                    <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.226562)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}
